export default __webpack_public_path__ + "static/media/qrcode_icon.1790dc88.svg";